<template>
  <div class="k-header" ref="header">
    <div class="k-header-con">
      <div class="k-header-logo">
        <a href="#">
          <img src="../../assets/images/logo-w.png" alt />
        </a>
      </div>
      <ul class="k-header-nav" ref="ulli">
        <template v-for="(item,index) in info.views.menus">
          <li
            :key="index"
            v-if="item.show == 'SHOW'"
            :class="index == info.indexClic ? 'hov' : ''"
            @click="clickMenu(index)"
          >
            <a>{{ item.label }}</a>
          </li>
        </template>
      </ul>
      <div class="k-header-login">
        <el-dropdown @command="actionSelect">
          <span class="el-dropdown-link k-nav-header">
            <img src="../../assets/images/admin.png" />
            【{{info.views.user.user_role}}】{{info.views.user.nickname}}
            <i
              class="el-icon-arrow-down el-icon--right"
            ></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="changePass">修改密码</el-dropdown-item>
            <el-dropdown-item command="logout" divided>退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <el-dialog
      title="修改密码"
      :visible.sync="info.changePassFormVisiable"
      :append-to-body="true"
      size="30%"
    >
      <div class="demo-drawer__content">
        <el-row>
          <el-col :span="22" :offset="1">
            <el-form
              :size="info.size"
              :model="info.changePassForm"
              ref="changePassForm"
              :rules="info.rules"
              label-width="110px"
            >
              <el-form-item label="当前密码" prop="password">
                <el-input
                  type="password"
                  v-model="info.changePassForm.password"
                  placeholder="请填写当前密码"
                ></el-input>
              </el-form-item>

              <el-form-item label="新密码" prop="newpass">
                <el-input
                  type="password"
                  v-model="info.changePassForm.newpass"
                  placeholder="请填写新密码"
                ></el-input>
              </el-form-item>

              <el-form-item label="再次输入" prop="repass">
                <el-input
                  type="password"
                  v-model="info.changePassForm.repass"
                  placeholder="请再次填写新密码"
                ></el-input>
              </el-form-item>

              <el-form-item label>
                <el-button type="primary" @click="changePass">提 交</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ['info'],
  data() {
    return {}
  },
  methods: {
    clickMenu: function(key) {
      this.info.indexClic = key
      this.info.clickMenus = this.info.views.menus[key].children
      this.$router.push(this.info.clickMenus[0].url)
    },
    actionSelect: function(command) {
      if (command == 'changePass') {
        this.changePassOpen()
      } else if (command == 'logout') {
        this.logout()
      }
    },
    changePassOpen: function() {
      this.info.changePassFormVisiable = true
    },
    changePass: function() {
      this.$refs['changePassForm'].validate(
        function(valid) {
          if (valid) {
            this.$confirm('此操作将修改您的登录密码, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
              .then(() => {
                this.$api.http
                  .post('index/changePassword', this.info.changePassForm)
                  .then(res => {
                    if (res && res.code == 0) {
                      this.$message({
                        type: 'success',
                        duration: 3000,
                        message: '密码修改成功'
                      })
                      setTimeout(() => {
                        this.$router.replace('/login')
                      }, 3000)
                    } else {
                      this.$message({
                        type: 'error',
                        message: res.message
                      })
                    }
                    this.info.changePassFormVisiable = false
                  })
              })
              .catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消修改'
                })
              })
          } else {
            this.$message({
              showClose: true,
              message: '请填写正确的信息！',
              type: 'warning'
            })
          }
        }.bind(this)
      )
    },
    logout: function() {
      this.$confirm('您将退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(
        function() {
          this.$api.http.post('index/logout').then(res => {
            if (res && res.code == 0) {
              this.$router.replace('/login')
            } else {
              this.$message({
                type: 'error',
                message: '退出登录失败'
              })
            }
          })
        }.bind(this)
      )
    }
  }
}
</script>
<style lang="scss" scoped>
.k-header {
  height: 64px;
  background: #041b39;
  z-index: 999;
}
.k-header-con {
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 1024px;
  height: 64px;
  font-size: 0;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background: #041b39;
  box-shadow: 0 2px 11px 0 rgba(0, 0, 0, 0.03);
}
.k-header-logo {
  display: inline-block;
  width: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  cursor: pointer;
}
.k-header-nav {
  flex: 1;
  height: 100%;
  vertical-align: top;
}
.k-header-nav li {
  position: relative;
  display: inline-block;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  float: left;
  height: 60px;
  line-height: 60px;
}
.k-header-nav li a {
  display: inline-block;
  padding: 22px 20px;
  font-size: 14px;
  line-height: 1.5;
  text-decoration: none !important;
  color: #9ca5b1;
}
.k-header-nav li a:hover {
  color: #fff;
}
.k-header-nav li.hov a {
  color: #fff;
}
.k-header-nav li.hov a::after {
  position: absolute;
  bottom: 11px;
  left: 50%;
  display: inline-block;
  width: 26px;
  height: 4px;
  content: '';
  background: #2f88ff;
  border-radius: 2px;
  transform: translateX(-50%);
}
.k-header-login {
  margin: 0 26px 0 24px;
}
.k-header-login .k-nav-header {
  color: #bfc6cd;
  font-size: 12px;
  font-weight: 400;
  display: flex;
  align-items: center;
}
.k-header-login .k-nav-header img {
  width: 24px;
  height: 24px;
  display: inline-block;
  margin-right: 8px;
}
.k-header-logo img {
  width: 104px;
}
</style>
